'use client';

import PromoTriangle from "@/components/promo-triangle";
import { Button } from "@/components/ui/button";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/20/solid";
import React from 'react';
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";

const SectionPromo = () => {
  const t = useTranslations("WaLinkPromo");
  const params = useParams();
  const isRTL = params.locale === 'ar';

  const handleButtonClick = (event: { preventDefault: () => void; }) => {
    event.preventDefault();

    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'G-EBHGYMR32B/minat_wabisnisapi_dari_walinkgenerator'
      });
    }

    window.location.href = '/get-a-quote?utm_source=whatsapp_api&utm_medium=button&utm_campaign=minat_wabisnisapi_dari_walinkgenerator';
  };

  const ChevronIcon = isRTL ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <section className="relative pb-28 pt-10 lg:pb-64 lg:pt-24">
      <PromoTriangle />
      <div className="container">
        <div className={`${isRTL ? 'lg:mr-auto' : 'lg:ml-auto'} lg:w-[45%]`}>
          <h2 className="max-w-md">
            {t("title")}
          </h2>
          <p className="mb-10 text-lg">
            {t("description")}
          </p>
          <a
            href="/get-a-quote/?utm_source=whatsapp_api&utm_medium=button&utm_campaign=minat_wabisnisapi_dari_walinkgenerator"
            onClick={handleButtonClick}
          >
            <Button>
              {t("button")}
              <ChevronIcon
                width={20}
                height={20}
                className={isRTL ? '-ml-2 mr-4' : '-mr-2 ml-4'}
              />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SectionPromo;

